import { render } from "./BaseListTable.vue?vue&type=template&id=2972776a"
import script from "./BaseListTable.vue?vue&type=script&lang=js"
export * from "./BaseListTable.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__